export const WelcomeContact = () => {
  window.location.href = "Welcome/contact.html";
  return <></>;
};